<template>
  <div class="init-container">
    <el-card class="init-box">
      <h2>账户初始化</h2>
      <el-form
        :model="initForm"
        :rules="rules"
        ref="initForm"
        label-width="120px"
      >
        <el-form-item label="新密码" prop="password">
          <el-input
            type="password"
            v-model="initForm.password"
            placeholder="请输入新密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            type="password"
            v-model="initForm.confirmPassword"
            placeholder="请再次输入新密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitInit" :loading="loading"
            >提交</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { init_user, validate_token } from "@/api/sso/login";

export default {
  name: "UserInit",
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 8) {
        callback(new Error("密码长度不能少于8位"));
      } else if (!/[A-Z]/.test(value)) {
        callback(new Error("密码必须包含大写字母"));
      } else if (!/[a-z]/.test(value)) {
        callback(new Error("密码必须包含小写字母"));
      } else if (!/[0-9]/.test(value)) {
        callback(new Error("密码必须包含数字"));
      } else if (!/[!@#$%^&*(),.?":{}|<>/\\\-_=+[\]~]/.test(value)) {
        callback(new Error("密码必须包含特殊字符（支持的特殊字符：!@#$%^&*(),.?\":{}|<>/\\-_=+[]~）"));
      } else {
        if (this.initForm.confirmPassword !== "") {
          this.$refs.initForm.validateField("confirmPassword");
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.initForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      initForm: {
        password: "",
        confirmPassword: "",
      },
      rules: {
        password: [{ validator: validatePass, trigger: "blur" }],
        confirmPassword: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  async created() {
    // 从cookie中获取用户身份信息
    const userToken = this.$cookies.get("reset_token");
    console.log(userToken)
    if (!userToken) {
      this.$message.error("请先登录");
      this.$router.push("/login");
      return;
    }

    // 这里可以添加额外的cookie校验逻辑
    // 例如调用API验证token有效性
    try {
      const rsp = await validate_token();
 
      if (!rsp || rsp.errcode !== 0 || !rsp.data.valid) {
        this.$router.push("/login");
      }
    } catch (error) {
      this.$router.push("/login");
    }
  },
  methods: {
    submitInit() {
      this.$refs.initForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            const response = await init_user({
              new_password: this.initForm.password,
            });

            if (response.errcode === 0) {
              this.$message.success("账号初始化成功");
              this.$router.push("/main/data-tasks/overview");
            } else {
              this.$message.error(response.errmsg || "密码设置失败");
            }
          } catch (error) {
            console.error("初始化错误:", error);
            this.$message.error(error.data?.errmsg || "请求失败");
          } finally {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.init-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.init-box {
  width: 500px;
  padding: 30px;
}

h2 {
  text-align: center;
  margin-bottom: 30px;
}
</style>
